"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** CreditCardIcon */
var CreditCardIcon = function CreditCardIcon(_ref) {
  var type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["type"]);

  var _ref2 = cardTypeMap[type] || cardTypeMap.Unknown,
      parts = _ref2.parts,
      title = _ref2.title;

  return _react.default.createElement(_Icon.Icon, _extends({
    viewBox: "0 0 30 20"
  }, rest), _react.default.createElement("title", null, title), parts);
};

exports.CreditCardIcon = CreditCardIcon;
CreditCardIcon.displayName = "CreditCardIcon";

var AmexIcon = function AmexIcon() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    fill: "#EFEFEF",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  }), _react.default.createElement("g", {
    fill: "#4DB3FF"
  }, _react.default.createElement("path", {
    d: "M9.999 11A.999.999 0 0 0 9 12.01v1.98c0 .558.439 1.01.999 1.01H30v-4H9.999zM0 6v4h20.001A.999.999 0 0 0 21 8.99V7.01A.999.999 0 0 0 20.001 6H0z"
  })), _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  })));
};

var DiscoverIcon = function DiscoverIcon() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    fill: "#EFEFEF",
    width: "30",
    height: "20",
    rx: "2"
  }), _react.default.createElement("path", {
    d: "M12 20h16.005A1.992 1.992 0 0 0 30 18.002V12l-18 8z",
    fill: "#FFB44F"
  }), _react.default.createElement("rect", {
    fill: "#D4D4D4",
    x: "5",
    y: "5",
    width: "20",
    height: "3",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  })));
};

var FallbackIcon = function FallbackIcon() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    fill: "#EFEFEF",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  }), _react.default.createElement("rect", {
    fill: "#D4D4D4",
    x: "5",
    y: "5",
    width: "20",
    height: "3",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    fill: "#D4D4D4",
    x: "5",
    y: "10",
    width: "7",
    height: "3",
    rx: "1.5"
  })));
};

var MastercardIcon = function MastercardIcon() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    fill: "#EFEFEF",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  }), _react.default.createElement("g", {
    transform: "translate(6 5)"
  }, _react.default.createElement("circle", {
    fill: "#FFB44F",
    cx: "13",
    cy: "5",
    r: "5"
  }), _react.default.createElement("circle", {
    fill: "#CE4747",
    cx: "5",
    cy: "5",
    r: "5"
  }), _react.default.createElement("path", {
    d: "M9 8a4.977 4.977 0 0 1-1-3c0-1.126.372-2.164 1-3 .628.836 1 1.874 1 3a4.977 4.977 0 0 1-1 3z",
    fill: "#D6765F"
  }))));
};

var VisaIcon = function VisaIcon() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    stroke: "#E5E5E5",
    fill: "#EFEFEF",
    x: ".5",
    y: ".5",
    width: "29",
    height: "19",
    rx: "2"
  }), _react.default.createElement("path", {
    d: "M0 14v4.002C0 19.106.898 20 1.992 20h26.016c1.1 0 1.992-.898 1.992-1.998V14H0z",
    fill: "#FFB44F"
  }), _react.default.createElement("path", {
    d: "M1.992 0C.892 0 0 .898 0 1.998V6h30V1.998A1.999 1.999 0 0 0 28.008 0H1.992z",
    fill: "#4287CB"
  })));
};

var cardTypeMap = {
  "American Express": {
    parts: _react.default.createElement(AmexIcon, null),
    title: "amex"
  },
  Discover: {
    parts: _react.default.createElement(DiscoverIcon, null),
    title: "discover"
  },
  MasterCard: {
    parts: _react.default.createElement(MastercardIcon, null),
    title: "mastercard"
  },
  Unknown: {
    parts: _react.default.createElement(FallbackIcon, null),
    title: "credit card"
  },
  Visa: {
    parts: _react.default.createElement(VisaIcon, null),
    title: "visa"
  }
};
//# sourceMappingURL=CreditCardIcon.js.map